export default {
  common: {
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    remove: 'Remover',
    next: 'Próximo',
    back: 'Voltar',
    loading: 'Carregando...',
    lightMode: 'Modo Claro',
    darkMode: 'Modo Escuro',
  },

  categories: {
    marketing: 'Marketing',
    marketingDesc: 'Promoções, ofertas e novidades',
    utility: 'Utilidade',
    utilityDesc: 'Notificações de pedidos, confirmações',
  },

  buttonTypes: {
    quickReply: 'Resposta Rápida',
    quickReplyDesc: 'Botão de resposta rápida (max 10)',
    url: 'Visitar Site',
    urlDesc: 'Link para site externo (max 1)',
  },

  headerTypes: {
    none: 'Nenhum',
    text: 'Texto',
    image: 'Imagem',
    document: 'Documento',
    video: 'Vídeo',
  },

  statuses: {
    all: 'Todos os status',
    pending: 'Em Análise',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
  },

  wizard: {
    title: 'Criar Template WhatsApp',
    editTitle: 'Editar Template WhatsApp',
    subtitle: 'Configure seu template de mensagem seguindo as diretrizes do Meta',
    editSubtitle: 'Altere o conteúdo do template e envie para re-aprovação',
    backToList: 'Voltar para Lista',
    submitting: 'Enviando...',
    finish: 'Finalizar',
    previewTitle: 'Preview da Mensagem',
    noChannelError: 'Nenhum canal selecionado. Selecione um canal WhatsApp.',
    submitError: 'Erro ao criar template',
    submitErrorGeneric: 'Ocorreu um erro ao salvar. Verifique os campos e tente novamente.',
    connectionError: 'Erro de conexão. Tente novamente.',
    unsavedChanges: 'Você tem alterações não salvas. Tem certeza que deseja sair?',
    steps: {
      info: 'Informações',
      type: 'Tipo',
      content: 'Conteúdo',
    },
    stepOf: 'Passo {current} de {total}',
    success: {
      title: 'Template Criado com Sucesso!',
      editTitle: 'Template Atualizado com Sucesso!',
      message: 'Seu template foi enviado para aprovação do Meta. Você será notificado quando for aprovado.',
      editMessage: 'Seu template foi atualizado e enviado para re-aprovação do Meta.',
      viewTemplates: 'Ver Templates',
      createAnother: 'Criar Outro',
    },
  },

  preview: {
    placeholder: 'Sua mensagem aparecerá aqui...',
    contact: 'Cliente',
    documentPlaceholder: 'Documento.pdf',
    button: 'Botão',
    realtimeLabel: 'Preview em tempo real',
    seeAllOptions: 'Ver todas as opções',
  },

  step1: {
    title: 'Informações do Template',
    subtitle: 'Configure as informações básicas do seu template de mensagem.',
    guidelinesTitle: 'Diretrizes do Meta',
    guidelineNameRule: 'O nome deve conter apenas letras minúsculas (a-z), números (0-9) e underline (_)',
    guidelineSpacesRule: 'Espaços são convertidos automaticamente para underline (_)',
    guidelineAccentsRule: 'Acentos e caracteres especiais são removidos automaticamente',
    guidelineLimitRule: 'Limite máximo de {max} caracteres',
    guidelineApprovalRule: 'Todos templates requerem aprovação do Meta',
    nameLabel: 'Nome do Template *',
    namePlaceholder: 'exemplo_nome_template',
    nameEditDisabled: 'Nome não pode ser alterado após criação',
    nameHint: 'Apenas letras minúsculas, números e underline (_). Espaços viram _',
    nameDuplicateHint: 'Já existe um template com este nome no idioma selecionado. Escolha um nome diferente ou altere o idioma.',
    categoryLabel: 'Categoria *',
    categoryEditDisabled: 'Categoria não pode ser alterada após criação',
    languageLabel: 'Idioma *',
    languageEditDisabled: 'Idioma não pode ser alterado após criação',
    channelLabel: 'Canal WhatsApp Associado *',
    channelPlaceholder: 'Selecione um canal',
    channelLoading: 'Carregando canais...',
  },

  step2: {
    title: 'Tipo de Template',
    subtitle: 'Escolha o tipo de mensagem que melhor se adapta ao seu caso de uso.',
    simpleTitle: 'Mensagem Simples',
    simpleDescription: 'Apenas texto, ideal para notificações rápidas',
    simpleFeatures: [
      'Somente texto no corpo',
      'Sem mídia ou botões',
      'Ideal para alertas',
    ],
    richTitle: 'Mensagem Rica',
    richDescription: 'Inclui cabeçalho, rodapé e botões interativos',
    richFeatures: [
      'Cabeçalho com texto ou mídia',
      'Botões interativos',
      'Rodapé opcional',
      'Maior engajamento',
    ],
  },

  step3: {
    title: 'Conteúdo do Template',
    subtitlePrefix: 'Configure o conteúdo da sua mensagem',
    subtitleRich: 'com cabeçalho, corpo, rodapé e botões.',
    subtitleSimple: 'de texto simples.',
    headerTitle: 'Cabeçalho',
    headerTextLabel: 'Texto do Cabeçalho',
    addVariable: '+ Adicionar Variável',
    headerPlaceholder: 'Título da mensagem',
    headerHint: 'Pode conter variáveis',
    imageLabel: 'Imagem',
    documentLabel: 'Documento',
    videoLabel: 'Vídeo',
    fileSelected: 'Arquivo selecionado',
    dropzoneText: 'Clique para selecionar ou arraste o arquivo',
    bodyTitle: 'Corpo da Mensagem *',
    bodyPlaceholder: 'Digite o conteúdo da mensagem aqui... Use chaves duplas para adicionar variáveis dinâmicas (autocompletado).',
    addButton: '+ Adicionar Botão',
    variablesLabel: 'Variáveis:',
    withVariables: '(com variáveis)',
    withoutVariables: '(sem variáveis)',
    proportionTitle: 'Proporção variáveis x caracteres:',
    proportionSingle: '{count} variável requer mínimo de {min} caracteres',
    proportionMulti: '{count} variáveis requerem mínimo de {min} caracteres',
    proportionPerVar: '({per} por variável)',
    proportionCurrent: 'Atual: {count} caracteres',
    proportionRemaining: '- faltam {remaining}',
    bodyRulesTitle: 'Regras do Corpo',
    bodyRule1: 'Não pode começar ou terminar com variável',
    bodyRule2: 'Não pode ter variáveis seguidas (ex:',
    bodyRule3: 'Pode ter quebra de linha simples, mas não duas ou mais consecutivas',
    bodyRule4: 'Limite de {withVars} caracteres com variáveis, {withoutVars} sem variáveis',
    bodyRule5: 'Proporção variáveis: 1 variável = 25 chars mínimo, 2+ variáveis = 20 chars por variável',
    variableValuesTitle: 'Valores de Exemplo das Variáveis',
    variableValuesDescription: 'Preencha os valores de exemplo para cada variável (obrigatório para aprovação).',
    variableValuePlaceholder: 'Valor de exemplo para variável {index}',
    variableValuesHint: 'Valores de exemplo sem limite de caracteres. Sem quebra de linha.',
    footerTitle: 'Rodapé',
    footerPlaceholder: 'Texto do rodapé (opcional)',
    footerHint: 'Rodapé não pode conter variáveis',
    buttonsTitle: 'Botões',
    buttonsEmpty: 'Nenhum botão adicionado',
    buttonsEmptyDetails: 'Máximo de 10 botões no total | Resposta Rápida: até {maxQuickReply} | URL: até {maxUrl}',
    buttonLabel: 'Botão {index}',
    buttonTypeLabel: 'Tipo',
    buttonTextLabel: 'Texto do Botão',
    buttonTextPlaceholder: 'Texto exibido',
    noUnderscore: 'Não pode conter underline (_)',
    buttonUrlLabel: 'URL *',
    buttonUrlPlaceholder: 'https://exemplo.com',
    buttonUrlHint: 'URL válida obrigatória. Max {max} caracteres.',
    buttonsCount: '{count}/10 botão(ões) adicionado(s)',
    quickReplyCount: 'Resposta Rápida:',
    buttonsLimitsTitle: 'Limites de Botões',
    buttonsLimitTotal: 'Máximo de 10 botões no total',
    buttonsLimitQuickReply: 'Resposta Rápida: até {max} botões, nomes diferentes, sem underline (_)',
    buttonsLimitUrl: 'Visitar Site: até {max} botão, URL válida obrigatória',
    limitReached: '(limite atingido)',
    quickReplyTitle: 'Resposta Rápida',
    ctaTitle: 'Chamada para Ação',
    optionalLabel: 'Opcional',
    addQuickReply: '+ Adicionar Resposta Rápida',
    addCta: '+ Adicionar Chamada para Ação',
    noQuickReplyButtons: 'Nenhum botão de resposta rápida',
    noCtaButtons: 'Nenhum botão de chamada para ação',
    quickReplyLabel: 'Resposta Rápida {index}',
    formatBold: 'Negrito',
    formatItalic: 'Itálico',
    formatStrikethrough: 'Tachado',
    formatMonospace: 'Monoespaçado',
  },

  detail: {
    backToList: 'Voltar para Lista',
    status: 'Status',
    category: 'Categoria',
    language: 'Idioma',
    type: 'Tipo',
    typeSimple: 'Simples',
    typeRich: 'Rico',
    header: 'Header',
    body: 'Corpo da Mensagem',
    footer: 'Rodape',
    buttons: 'Botoes',
    preview: 'Preview da Mensagem',
    notFound: 'Template nao encontrado',
    loadError: 'Erro ao carregar template',
  },

  listing: {
    title: 'WhatsApp Templates',
    subtitle: 'Gerencie seus templates de mensagem WhatsApp',
    createNew: 'Criar Novo Modelo',
    filterName: 'Nome',
    filterNamePlaceholder: 'Buscar por nome ou ID...',
    filterStatus: 'Status',
    filterChannel: 'Canal',
    filterCategory: 'Categoria',
    allCategories: 'Todas as categorias',
    emptyTitle: 'Nenhum template encontrado',
    emptyFiltered: 'Tente ajustar os filtros de busca',
    emptyNoTemplates: 'Crie seu primeiro template para começar',
    createFirst: 'Criar Primeiro Template',
    colNameId: 'Nome / ID',
    colStatus: 'Status',
    colLanguage: 'Idioma',
    colModified: 'Modificado',
    colCategory: 'Categoria',
    colActions: 'Ações',
    copyId: 'Copiar ID',
    copied: 'Copiado!',
    edit: 'Editar',
    delete: 'Excluir',
    cantEditPending: 'Não é possível editar templates em análise',
    cantEditRejected: 'Não é possível editar templates rejeitados',
    cantDeletePending: 'Não é possível excluir templates em análise',
    cantDeleteRejected: 'Não é possível excluir templates rejeitados',
    showing: 'Mostrando {start}-{end} de {total}',
    previous: 'Anterior',
    next: 'Próximo',
    deleteTitle: 'Excluir Template',
    deleteMessage: 'Tem certeza que deseja excluir o template \'{name}\'? Esta ação não pode ser desfeita.',
    deleteMessageWarning: 'Tem certeza que deseja excluir o template \'{name}\'? Esta ação não pode ser desfeita e o template não estará mais disponível para envio de mensagens.',
    deleteConfirm: 'Excluir',
    deleteError: 'Erro ao excluir template. Tente novamente.',
    deleting: 'Excluindo...',
  },

  editWarning: {
    title: 'Editar Template',
    description: 'Editar este template exigirá uma nova aprovação da Meta. Fique ciente do seguinte:',
    item1: 'O template voltará ao status "Em Análise" e pode levar até 24 horas para ser aprovado novamente.',
    item2: 'O template ficará indisponível para envio de mensagens até ser aprovado novamente.',
    confirm: 'Editar mesmo assim',
  },

  categoryMismatch: {
    title: 'A categoria não corresponde',
    description: 'Para garantir que seu modelo de mensagem seja aprovado, escolha uma categoria adequada para o conteúdo deste modelo.',
    marketingDesc: 'Envie promoções, ofertas e novidades para aumentar o engajamento.',
    utilityLabel: 'Utilidade',
    utilityDesc: 'Envie mensagens sobre uma conta ou pedido existente.',
    authenticationLabel: 'Autenticação',
    authenticationDesc: 'Envie códigos para verificar uma transação ou login.',
    selected: 'Selecionado',
    recommended: 'Recomendado',
    warning: 'Este modelo de mensagem será rejeitado. Você pode solicitar uma análise na Página Inicial do Suporte para Empresas.',
    continue: 'Continuar',
  },

  validation: {
    nameRequired: 'Nome é obrigatório',
    nameMinLength: 'Nome deve ter pelo menos 3 caracteres',
    nameMaxLength: 'Nome deve ter no máximo {max} caracteres',
    namePattern: 'Use apenas letras minúsculas, números e underline (_)',
    nameDuplicate: 'Já existe um template com este nome no idioma selecionado',
    phoneRequired: 'Número de telefone é obrigatório',
    templateTypeRequired: 'Tipo de template é obrigatório',
    bodyRequired: 'Corpo da mensagem é obrigatório',
    bodyNoStartVariable: 'Corpo não pode começar com variável',
    bodyNoEndVariable: 'Corpo não pode terminar com variável',
    bodyNoConsecutiveVariables: 'Corpo não pode ter variáveis consecutivas sem texto entre elas',
    bodyNoConsecutiveVariablesShort: 'Não pode ter variáveis seguidas',
    bodyNoDoubleLineBreaks: 'Corpo não pode ter duas ou mais quebras de linha consecutivas',
    bodyMaxLength: 'Corpo deve ter no máximo {max} caracteres ({type} variáveis)',
    bodyMinLengthSingle: 'Corpo deve ter no mínimo {min} caracteres quando tem 1 variável',
    bodyMinLengthMulti: 'Corpo deve ter no mínimo {min} caracteres quando tem {count} variáveis (20 por variável)',
    headerTextRequired: 'O texto do cabeçalho é obrigatório',
    headerMaxLength: 'Cabeçalho deve ter no máximo {max} caracteres',
    footerMaxLength: 'Rodapé deve ter no máximo {max} caracteres',
    footerNoVariables: 'Rodapé não pode conter variáveis',
    buttonTextRequired: 'Todos os botões devem ter texto',
    buttonTextMaxLength: 'Texto do botão deve ter no máximo {max} caracteres',
    buttonNoUnderscore: 'Botão de resposta rápida não pode conter underline (_)',
    urlRequiredForSite: 'URL é obrigatória para botão de site',
    urlRequired: 'URL é obrigatória',
    urlInvalid: 'URL inválida',
    urlMaxLength: 'URL deve ter no máximo {max} caracteres',
    phoneRequiredForCall: 'Telefone é obrigatório para botão de ligação',
    codeRequired: 'Código é obrigatório',
    codeRequiredForCopy: 'Código é obrigatório para botão de copiar código',
    codeMaxLength: 'Código deve ter no máximo {max} caracteres',
    variableRequired: 'Valor de exemplo é obrigatório',
    variableNoLineBreak: 'Valor da variável não pode ter quebra de linha',
    variableLabel: 'Variável {index}',
    buttonsMaxTotal: 'Máximo de 10 botões no total',
    buttonsUniqueNames: 'Nomes dos botões devem ser diferentes',
    buttonsMaxQuickReply: 'Máximo de {max} botões de resposta rápida',
    buttonsMaxUrl: 'Máximo de {max} botão de URL',
    buttonsMaxPhone: 'Máximo de {max} botão de telefone',
    buttonsMaxCopyCode: 'Máximo de {max} botão de copiar código',
    mediaFileRequired: 'Selecione um arquivo para o cabeçalho (vídeo ou documento)',
    mediaAccentWarning: 'Arquivo com acento no nome pode não ser enviado (limitação da Meta)',
  },
} as const
